import React, { useEffect, useId, useRef, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";

function PortalFieldInfo({ children, label = "More info" }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const tipId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const handleOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  return (
    <span className="cportal-field-info" ref={wrapRef}>
      <button
        type="button"
        className="cportal-field-info-btn"
        aria-label={label}
        aria-expanded={open}
        aria-describedby={open ? tipId : undefined}
        onClick={() => setOpen((v) => !v)}
      >
        <FaInfoCircle aria-hidden="true" />
      </button>
      {open ? (
        <span id={tipId} role="tooltip" className="cportal-field-info-tip">
          {children}
        </span>
      ) : null}
    </span>
  );
}

export default PortalFieldInfo;
